import { namespacedClassnames } from '../../../common/namespace-classes';
import * as React from 'react';
import { Tooltip } from '../..';
export var InternalRadioButton = function (props) {
    var classes = namespacedClassnames('inner-radio-button');
    var onChange = function () { return !props.disabled ? props.onSelect() : null; };
    var radioIcon = React.createElement("span", { className: 'radio-icon' });
    return (React.createElement("div", { className: classes },
        React.createElement("input", { style: { display: 'none' }, type: 'radio', checked: props.checked, onChange: onChange, disabled: props.disabled }),
        props.tooltipButton && props.disabled ? React.createElement(Tooltip, { body: props.tooltipButton }, radioIcon) : radioIcon,
        React.createElement("span", { className: 'radio-body' }, props.children)));
};
//# sourceMappingURL=internal-radio-button.js.map